export default "__VITE_ASSET__BYs6aSYl__"